import React, { FC } from 'react'
import { Icon, IconProps } from '@chakra-ui/react'

const Sun: FC<IconProps> = (props) => (
  <Icon
    aria-label="sun icon"
    fill="none"
    viewBox="0 0 19 19"
    // ChakraUIs type definitions clash apparently.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {...(props as any)}
    stroke="currentColor">
    <path
      d="M9.4 12.3a2.9 2.9 0 100-5.8 2.9 2.9 0 000 5.8z"
      strokeMiterlimit="10"
      strokeWidth="2"
    />
    <path
      d="M9.4 15.9v1.9M9.4 1v1.9M15.9 9.4h1.9M1 9.4h1.9M14 4.8l1.4-1.3M3.5 15.4L4.8 14M4.8 4.8L3.5 3.5M15.4 15.4L14 14"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
    />
  </Icon>
)

// eslint-disable-next-line functional/immutable-data
Sun.displayName = 'Sun'

export { Sun }
